<template>
  <form-row>
    <label for="start-date" class="ordered-counter">
      {{ $t('product-detail.form.date-effective.label') }}
    </label>

    <date-picker id="start-date"
                 :min-date="minDate"
                 :max-date="maxDate"
                 :value="value"
                 @input="setValue"
    />

    <ul v-if="validation.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
      <li v-if="!validation.required">{{ $t('product-detail.form.date-effective.validation.required') }}</li>
    </ul>
  </form-row>
</template>

<script>
import DatePicker from '../components/DatePicker'
import FormRow from '../components/FormRow'

export default {
  components: {
    DatePicker,
    FormRow
  },
  props: {
    value: {
      type: Date,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    validation: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    value: function (value) {
      this.value = value
    }
  },
  methods: {
    setValue: function (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/order-item/DateEffective.vue